  (function () {
    // Config travels on this script tag, so one cached file serves every
    // caller (4 instances on the homepage) instead of 4 inline copies.
    var me = document.currentScript;
    if (!me || !me.dataset.sectionId) return;
    var sectionEl = document.getElementById('shopify-section-' + me.dataset.sectionId);
    if (!sectionEl) return;
    var IMGS = 'img[data-defer-src]';

    function hydrate(img) {
      if (!img || img.__deferHydrated) return;
      img.__deferHydrated = true;
      var ss = img.getAttribute('data-defer-srcset');
      if (ss) { img.setAttribute('srcset', ss); img.removeAttribute('data-defer-srcset'); }
      var s = img.getAttribute('data-defer-src');
      if (s) { img.setAttribute('src', s); img.removeAttribute('data-defer-src'); }
    }
    function hydrateAll() {
      sectionEl.querySelectorAll(IMGS).forEach(hydrate);
    }

    if (!('IntersectionObserver' in window)) { hydrateAll(); return; }

    function armScrollers() {
      var scrollers = sectionEl.querySelectorAll(me.dataset.scrollerSelector);
      if (!scrollers.length) { hydrateAll(); return; }
      scrollers.forEach(function (scroller) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { hydrate(e.target); io.unobserve(e.target); }
          });
        }, { root: scroller, rootMargin: '200px 600px' });
        scroller.querySelectorAll(IMGS).forEach(function (img) { io.observe(img); });
      });
      // Anything outside a matched scroller still hydrates on approach.
      sectionEl.querySelectorAll(IMGS).forEach(function (img) {
        var inScroller = false;
        scrollers.forEach(function (s) { if (s.contains(img)) inScroller = true; });
        if (!inScroller) hydrate(img);
      });
    }

    function start() {
      var approach = new IntersectionObserver(function (entries, obs) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { obs.disconnect(); armScrollers(); return; }
        }
      }, { rootMargin: '400px 0px' });
      approach.observe(sectionEl);
    }

    var gate = (window.DFYNE && window.DFYNE.heroReady && window.DFYNE.heroReady.then)
      ? window.DFYNE.heroReady : Promise.resolve();
    gate.then(start, start);

    // Failsafe: after load + idle, everything left hydrates regardless —
    // guarantees the strip is fully populated long before it could matter,
    // without ever touching the LCP window.
    window.addEventListener('load', function () {
      var schedule = window.requestIdleCallback
        ? function (cb) { window.requestIdleCallback(cb, { timeout: 10000 }); }
        : function (cb) { setTimeout(cb, 4000); };
      schedule(hydrateAll);
    });
  })();
